import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Promotion Scratcher Settings</h4>
    </div>
  );
};
